import React from 'react'

export default function Header(props) {
 
  return (
 
  <div className="list-books-title">
              <h1>MyReads</h1>
            </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Header.js